export enum EContactsListDisplaying {

	name = "name",
	address = "address",
	birthDate = "birthDate",
	email = "email",
	phone = "phone",
	profession = "profession",
	picture = "picture"
}